import React, { useMemo } from 'react';
import { MarkSelect, MarkLabel } from '../../../components/MarkControls';
import type { SegmentAttribute } from '../../../types';
import * as styles from './style.module.css';

type Props = {
    value: string;
    attributes: SegmentAttribute[];
    onChange: (attributeName: string) => void;
    id: string;
};
const GROUP_LABELS: Record<string, string> = {
    profile: 'Profile',
    membership: 'Membership',
    prospect: 'Prospect'
};

const AttributeSelect: React.FC<Props> = ({ value, attributes, onChange, id }) => {
    const grouped = useMemo(() => {
        const groups: Record<string, SegmentAttribute[]> = {};
        for (const attribute of attributes) (groups[attribute.group] ??= []).push(attribute);
        return groups;
    }, [attributes]);
    return (
        <div className={styles.field}>
            <MarkLabel htmlFor={id} style={{ margin: 0 }}>
                Field
            </MarkLabel>
            <MarkSelect
                id={id}
                value={value}
                onChange={(event) => onChange(event.currentTarget.value)}
                style={{ width: '100%' }}
            >
                <option value="">Choose a field</option>
                {Object.entries(grouped).map(([group, items]) => (
                    <optgroup key={group} label={GROUP_LABELS[group] ?? group}>
                        {items.map((attribute) => (
                            <option key={attribute.name} value={attribute.name}>
                                {attribute.label}
                            </option>
                        ))}
                    </optgroup>
                ))}
            </MarkSelect>
        </div>
    );
};
export default AttributeSelect;
